export const Breed = {
  PetName: 'pet-name',
  PetBreed: 'pet-breed',
  PetGenderPrefix: 'gender',
  BackBtn: 'back-btn',
  NextBtn: 'next-btn',
} as const;
